import axios from "axios";
import baseURL from "../config";
import { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";

const CompanyVessel = () => {
  const [company, setCompany] = useState([]);

  const email = localStorage.getItem("userEmail");

  const fetchCompanyDetails = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/company/${email}`);
      setCompany([response.data.data]);
      
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  return (
    <>
      <Navbar />
      <div className="p-4 space-y-8">
        {company.map((company, index) => (
          <div key={company._id || index} className="bg-white p-6 rounded-lg shadow-lg">
            {/* Add Executive Button */}
            <div className="text-center mb-6">
              <Link to={`/ExecutiveForm/${company.userId}`}>
                <button className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition">
                  {"Add Executive"}
                </button>
              </Link>
            </div>

            {/* Vessel Owner Table */}
            <h3 className="text-2xl font-semibold text-center mb-4">Vessel Owner</h3>
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="border-b">
                  <th className="px-4 py-2 text-left">Company Name</th>
                  <th className="px-4 py-2 text-left">Address</th>
                  <th className="px-4 py-2 text-left">Email</th>
                  <th className="px-4 py-2 text-left">Phone No.</th>
                  <th className="px-4 py-2 text-left">Country</th>
                  <th className="px-4 py-2 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="px-4 py-2">{company.companyName}</td>
                  <td className="px-4 py-2">{company.address}</td>
                  <td className="px-4 py-2">{company?.email}</td>
                  <td className="px-4 py-2">{company.phoneNumber}</td>
                  <td className="px-4 py-2">{company.country}</td>
                  <td className="px-4 py-2 text-blue-500">
                    <Link to={`/ExecutiveTable/${company.userId}`}>
                      <FaPlus className="text-xl hover:text-blue-600 transition" />
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </>
  );
};

export default CompanyVessel;
